import { Box, Slider, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { LuX } from 'react-icons/lu'

import DraggableContainer from '@/components/DraggableContainer'
import Icon from '@/components/Icon'

import { IMAGE_SIZE } from './EnamelStudio'

interface EnamelStudioImageSliderProps {
  dimensions: { width: number; height: number }
  src: string
  name: string
  onDeleteImage: (name: string) => void
}

const EnamelStudioImageSlider: React.FC<EnamelStudioImageSliderProps> = ({
  dimensions,
  src,
  name,
  onDeleteImage,
}) => {
  const theme = useTheme()
  const [value, setValue] = useState<number>(1)

  const handleChange = (event: Event, newValue: number | number[]) => {
    event.preventDefault()
    event.stopPropagation()
    setValue(newValue as number)
  }

  return (
    <DraggableContainer
      bounds="parent"
      defaultPosition={{
        x: dimensions?.width ? dimensions?.width - IMAGE_SIZE : 0,
        y: dimensions?.height / 3,
      }}
    >
      <Box>
        <Box
          color={theme.palette.common.white}
          fontSize="16px"
          lineHeight="normal"
          fontWeight={700}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box
            sx={{
              width: '130px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {name}
          </Box>
          <Icon
            size={24}
            icon={LuX}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              onDeleteImage(name)
            }}
            color={theme.palette.common.white}
          />
        </Box>
        <Box
          sx={{
            backgroundImage: `url(${src})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: '150px',
            height: '150px',
            opacity: value,
          }}
        ></Box>
        <Box
          onMouseDown={(e) => {
            e.stopPropagation()
          }}
          onTouchStart={(e) => {
            e.stopPropagation()
          }}
        >
          <Slider
            min={0}
            max={1}
            step={0.01}
            value={value}
            valueLabelDisplay="auto"
            valueLabelFormat={(value) => value.toFixed(2)}
            onChange={handleChange}
            sx={{
              color: theme.palette.background.paper,
              '& .MuiSlider-thumb': {
                backgroundColor: theme.palette.common.white,
                width: '14px',
                height: '14px',
              },
              '& .MuiSlider-track': {
                backgroundColor: theme.palette.background.paper,
                height: '3px',
              },
              '& .MuiSlider-rail': {
                backgroundColor: theme.palette.background.paper,
                height: '3px',
              },
            }}
          />
        </Box>
      </Box>
    </DraggableContainer>
  )
}

export default EnamelStudioImageSlider
